// extracted by mini-css-extract-plugin
export var containerEmptyIcon = "ContentBox-module__containerEmptyIcon___39ChL";
export var containerRow = "ContentBox-module__containerRow___xLl4K";
export var contentBox = "ContentBox-module__contentBox___HBvlj";
export var disabledContentBox = "ContentBox-module__disabledContentBox___Hn9C+";
export var disabledText = "ContentBox-module__disabledText___Iv6FO";
export var iconWrapper = "ContentBox-module__iconWrapper___bMhfL";
export var medium = "860px";
export var rightSideButton = "ContentBox-module__rightSideButton___cyV3S";
export var rightSideLink = "ContentBox-module__rightSideLink___AZ7gg";
export var rightSideLinkIconWrapper = "ContentBox-module__rightSideLinkIconWrapper___PxHp2";
export var rightSideLinkWrapper = "ContentBox-module__rightSideLinkWrapper___RZJRO";
export var rightSideTextWrapper = "ContentBox-module__rightSideTextWrapper___kSEwq";
export var subtitle = "ContentBox-module__subtitle___pqJs8";
export var title = "ContentBox-module__title___cI6Fh";
export var titleRightSideText = "ContentBox-module__titleRightSideText___FhKaI";
export var xboxGreen = "#107C10";